/* Hover magnifier for the main product image. Desktop/hover-capable devices
   only — a circular lens follows the cursor and shows a zoomed-in crop of
   whatever part of the photo it's over, like a magnifying glass.

   Listeners are bound to each slide's .product__modal-opener (the element
   that wraps the photo + the invisible click target that opens the
   fullscreen modal) rather than the image itself, because that click
   target's ::after pseudo-element sits on top of the photo (z-index: 2) and
   would otherwise eat the mousemove/mouseleave events before they reached
   the image. Binding on the shared ancestor lets the events bubble up
   naturally regardless of which element the browser hit-tests. */
document.addEventListener('DOMContentLoaded', () => {
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  const ZOOM = 2.5;
  const LENS_SIZE = 180;

  let lens = null;
  let lensSrc = '';

  function ensureLens() {
    if (!lens) {
      lens = document.createElement('div');
      lens.className = 'lr-zoom-lens';
      document.body.appendChild(lens);
    }
    return lens;
  }

  function hideLens() {
    if (lens) lens.style.opacity = '0';
  }

  // Object-fit: contain lets the box (fixed aspect ratio) and the photo's
  // own aspect ratio differ, letterboxing the image inside the box. This
  // finds the actual rendered photo rect within that box so the lens maps
  // to the right pixels instead of drifting into the letterbox margins.
  function containedRect(box, naturalWidth, naturalHeight) {
    const boxRatio = box.width / box.height;
    const imgRatio = naturalWidth / naturalHeight;
    let width, height;
    if (imgRatio > boxRatio) {
      width = box.width;
      height = width / imgRatio;
    } else {
      height = box.height;
      width = height * imgRatio;
    }
    return {
      left: box.left + (box.width - width) / 2,
      top: box.top + (box.height - height) / 2,
      width,
      height,
    };
  }

  // Requests a sharper version of the same Shopify CDN image than whatever
  // srcset candidate the browser picked, so the zoomed-in lens isn't blurry.
  function zoomSrc(img) {
    try {
      const url = new URL(img.currentSrc || img.src, window.location.href);
      url.searchParams.set('width', '2048');
      return url.toString();
    } catch (error) {
      return img.currentSrc || img.src;
    }
  }

  document.querySelectorAll('.product__media-list .product__modal-opener').forEach((opener) => {
    const img = opener.querySelector('.media > img');
    if (!img) return;

    opener.addEventListener('mousemove', (event) => {
      if (!img.naturalWidth) return;

      const box = img.getBoundingClientRect();
      const content = containedRect(box, img.naturalWidth, img.naturalHeight);
      const x = event.clientX;
      const y = event.clientY;

      if (x < content.left || x > content.left + content.width || y < content.top || y > content.top + content.height) {
        hideLens();
        return;
      }

      const el = ensureLens();
      const src = zoomSrc(img);
      if (src !== lensSrc) {
        el.style.backgroundImage = `url("${src}")`;
        lensSrc = src;
      }

      const relX = (x - content.left) / content.width;
      const relY = (y - content.top) / content.height;
      const bgWidth = content.width * ZOOM;
      const bgHeight = content.height * ZOOM;

      el.style.backgroundSize = `${bgWidth}px ${bgHeight}px`;
      el.style.backgroundPosition = `${-(relX * bgWidth - LENS_SIZE / 2)}px ${-(relY * bgHeight - LENS_SIZE / 2)}px`;
      el.style.left = `${x - LENS_SIZE / 2}px`;
      el.style.top = `${y - LENS_SIZE / 2}px`;
      el.style.opacity = '1';
    });

    opener.addEventListener('mouseleave', hideLens);
  });
});
